

















import {Component, Vue, Watch} from "vue-property-decorator";
import {PickingListDeliveryPartnerParams} from "../../../params";
import MillisecondDatePicker from "../../../../../shared/components/MillisecondDatePicker/index.vue";
import {PartnerType} from "@/enums/type";
import {PickingListDeliveryStore} from "../../../store";
import { debounce } from 'lodash';
import PartnerSelector from "@/shared/components/PartnerSelector/index.vue";
import AInputBarCode from "@/shared/components/InputBarCode/index.vue";

@Component({
    name: "PLDeliverySearchPartner",
    components: {AInputBarCode, PartnerSelector, MillisecondDatePicker}
})
export default class extends Vue {
    PartnerType = PartnerType;
    search = new PickingListDeliveryPartnerParams();

    @Watch("search", { immediate: false, deep: true })
    onSearch(val: any, oldVal: any) {
        this.handleChangeSearch(val);
    }

    handleChangeSearch = debounce((val: any) => {
        PickingListDeliveryStore.updatePickingListDeliveryParams({ ...PickingListDeliveryStore.params, ...val });
        PickingListDeliveryStore.listPickingListDeliveryForPartner({...PickingListDeliveryStore.params, page: 1});
    }, 500)

    onEnterPickingListCode(evt: any) {
        this.$set(this.search, 'code', evt?.target?.value || undefined);
    }
}
